/* HOMEPAGE · THE RULES — the pinned living room (sections/nhp-home-05-rules.liquid, rebuilt 2026-09-22).
   Scroll through the section and it plays four scenes, one per rule (data-act 0–3):
     0  lamp on · the TV flips channels through the films · the jar on the table matches the channel
     1  lamp off · the movie starts · the room is lit by the picture (sampled a few times a second, smoothed)
     2  lightning — and in the flash, someone is on the couch
     3  lightning again — he's gone, so is the jar; the TV drops to snow
   Each scene has its own camera: on a phone it pans across the room (TV → the couch → back to the table),
   on a wide screen it holds the whole room and leans in. Scrolling back up plays it backwards, quietly. */
(function () {
  var root = document.querySelector('[data-nhp-rules]');
  if (!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;
  var stage = root.querySelector('.nhp-rules__stage');
  var cam = root.querySelector('[data-nhp-cam]');
  var video = root.querySelector('[data-nhp-tv-video]');
  var snow = root.querySelector('[data-nhp-snow]');
  var power = root.querySelector('[data-nhp-tv-power]');
  var osd = root.querySelector('[data-nhp-tv-osd]');
  var chans = root.querySelectorAll('.nhp-rules__chan');
  var jars = root.querySelectorAll('[data-nhp-jar]');
  var rules = root.querySelectorAll('.nhp-rules__rule');
  var ticks = root.querySelectorAll('.nhp-rules__ticks i');
  var ACTS = 4;

  /* ---- the camera: where each scene looks (fractions of the room art) and how much of its width shows ---- */
  var SHOTS = {
    tall: [ { x: 0.63, y: 0.42, span: 0.40 }, { x: 0.645, y: 0.36, span: 0.30 },
            { x: 0.21, y: 0.53, span: 0.42 }, { x: 0.60, y: 0.48, span: 0.40 } ],
    wide: [ { x: 0.50, y: 0.34, span: 1.00 }, { x: 0.62, y: 0.40, span: 0.78 },   /* y kept high enough that */
            { x: 0.36, y: 0.40, span: 0.82 }, { x: 0.56, y: 0.36, span: 0.90 } ]    /* the TV clears the heading */
  };
  var shots = [];
  function measure() {
    var vw = stage.clientWidth, vh = stage.clientHeight;
    var set = vw / vh < 1.1 ? SHOTS.tall : SHOTS.wide;
    var wmax = 0;
    shots = set.map(function (s) {
      var w = vw / s.span;
      if (w * 0.75 < vh) w = vh / 0.75;          // always cover the screen — never show an edge of the art
      wmax = Math.max(wmax, w);
      var h = w * 0.75;
      var x = Math.min(0, Math.max(vw - w, vw / 2 - s.x * w));
      var y = Math.min(0, Math.max(vh - h, vh * 0.44 - s.y * h));   // a little high: the words sit at the bottom
      return { w: w, x: x, y: y };
    });
    cam.style.setProperty('--cam-w', wmax.toFixed(1) + 'px');
    shots.forEach(function (s) { s.s = s.w / wmax; });
    aim(true);
  }
  function aim(instant) {
    var s = shots[act];
    if (!s) return;
    if (instant) cam.style.transition = 'none';
    cam.style.setProperty('--cam-x', s.x.toFixed(1) + 'px');
    cam.style.setProperty('--cam-y', s.y.toFixed(1) + 'px');
    cam.style.setProperty('--cam-s', s.s.toFixed(4));
    if (instant) { void cam.offsetWidth; cam.style.transition = ''; }
  }

  /* ---- state ---- */
  var act = -1;
  var onScreen = false;
  var paused = false;
  var timers = [];
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearLater() { timers.forEach(clearTimeout); timers = []; }

  /* lightning: a double snap, ≤2 flashes inside 300ms. `atPeak` runs in the first flash — that's when he moves */
  function strike(atPeak) {
    if (reduce) { atPeak(); return; }
    var hit = function (on) {
      root.classList.toggle('is-strike', on);
      html.classList.toggle('nhp-strike', on);   // the rest of the site answers it too
    };
    html.style.setProperty('--si', '0.95');
    root.style.setProperty('--si', '0.95');
    hit(true);
    atPeak();
    later(function () { hit(false); }, 90);
    later(function () { hit(true); }, 210);
    later(function () { hit(false); html.style.removeProperty('--si'); }, 330);
  }

  /* ---- the TV ---- */
  var chan = 0;
  var tuning = false;
  function showChannel(i) {
    chan = chans.length ? (i + chans.length) % chans.length : 0;
    [].forEach.call(chans, function (c, n) { c.classList.toggle('is-on', n === chan); });
    [].forEach.call(jars, function (j, n) { j.classList.toggle('is-on', n === chan); });
  }
  function tune(ms, then) {
    tuning = true;
    root.classList.add('is-tuning');
    later(function () { tuning = false; root.classList.remove('is-tuning'); if (then) then(); }, ms);
  }
  var flipTimer = null;
  function flipping(on) {
    clearInterval(flipTimer);
    flipTimer = null;
    if (!on || !chans.length) return;
    flipTimer = setInterval(function () {
      /* the jar goes with the picture: gone in the static, back with the new channel — never mismatched */
      [].forEach.call(jars, function (j) { j.classList.remove('is-on'); });
      tune(160, function () { showChannel(chan + 1); });
    }, 1900);
  }

  function playing() {
    return !paused && onScreen && !document.hidden && (act === 1 || act === 2);
  }
  function apply() {
    var live = onScreen && !document.hidden && !paused;
    if (video) {
      if (playing() && !reduce) {
        if (video.preload !== 'auto') video.preload = 'auto';
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    }
    flipping(live && act === 0 && !reduce);
    snowing(live && !reduce && (act === 3 || tuning));
  }

  /* snow: a tiny canvas of noise, redrawn while it shows */
  var snowTimer = null;
  var sctx = snow && snow.getContext('2d');
  function drawSnow() {
    if (!sctx) return;
    var img = sctx.createImageData(snow.width, snow.height), d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      var v = Math.random() * 235;
      d[i] = d[i + 1] = d[i + 2] = v;
      d[i + 3] = 255;
    }
    sctx.putImageData(img, 0, 0);
  }
  function snowing(on) {
    if (on && !snowTimer) snowTimer = setInterval(drawSnow, 70);
    if (!on && snowTimer) { clearInterval(snowTimer); snowTimer = null; }
  }
  drawSnow();

  /* ---- the scenes ---- */
  function setAct(n) {
    if (n === act) return;
    var prev = act;
    act = n;
    root.setAttribute('data-act', n);
    [].forEach.call(rules, function (r, i) { r.classList.toggle('is-on', i === n); });
    [].forEach.call(ticks, function (t, i) { t.classList.toggle('is-on', i <= n); });
    clearLater();
    root.classList.remove('is-strike', 'is-tuning');
    html.classList.remove('nhp-strike');
    tuning = false;
    aim(prev === -1);

    var forward = n > prev && prev !== -1;
    if (n === 0) {
      root.classList.remove('has-watcher', 'is-taken');
      root.style.setProperty('--tv-lum', '0.3');
    }
    if (n === 1) {
      root.classList.remove('has-watcher', 'is-taken');
      if (forward && !reduce) tune(320, apply);   // the channel gives way to the movie
    }
    if (n === 2) {
      root.classList.remove('is-taken');
      if (forward) later(function () { strike(function () { root.classList.add('has-watcher'); }); }, 1300);   // once the camera has nearly reached the couch
      else root.classList.add('has-watcher');
    }
    if (n === 3) {
      root.style.setProperty('--tv-lum', '0.45');   // snow throws a flat grey light
      if (forward) {
        later(function () {
          strike(function () { root.classList.remove('has-watcher'); root.classList.add('is-taken'); });
        }, 250);   // while he is still in shot
      } else {
        root.classList.remove('has-watcher');
        root.classList.add('is-taken');
      }
    }
    apply();
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var r = root.getBoundingClientRect();
      var run = root.offsetHeight - stage.clientHeight;
      var p = run > 0 ? Math.min(1, Math.max(0, -r.top / run)) : 0;
      setAct(Math.min(ACTS - 1, Math.floor(p * ACTS * 1.12)));   // the last scene holds for the tail of the run
    });
  }

  /* ---- pause (tap the picture) + the VCR readout ---- */
  var osdTimer = null;
  if (power) power.addEventListener('click', function () {
    paused = !paused;
    power.setAttribute('aria-pressed', paused ? 'true' : 'false');
    power.querySelector('.nhp-sr').textContent = paused ? 'Play the TV' : 'Pause the TV';
    if (osd) {
      clearTimeout(osdTimer);
      osd.textContent = paused ? 'II PAUSE' : '▶ PLAY';
      osd.classList.add('is-shown');
      if (!paused) osdTimer = setTimeout(function () { osd.classList.remove('is-shown'); }, 1800);
    }
    apply();
  });

  document.addEventListener('visibilitychange', apply);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { onScreen = e[0].isIntersecting; apply(); }, { rootMargin: '100px 0px' }).observe(root);
  } else {
    onScreen = true;
  }

  showChannel(0);
  measure();
  setAct(0);
  onScroll();

  /* ---- the light the picture throws ---- */
  if (reduce || !video) return;
  var canvas = document.createElement('canvas');
  canvas.width = 16;
  canvas.height = 12;
  var ctx = canvas.getContext('2d', { willReadFrequently: true });
  var lum = 0.3;
  var EASE = 0.3;       // quick enough to flicker with the cuts, too slow to strobe (WCAG 2.3.1)
  var timer = null;
  var blocked = false;
  function sample() {
    if (video.paused || video.readyState < 2) return;
    var d;
    try {
      ctx.drawImage(video, 0, 0, 16, 12);
      d = ctx.getImageData(0, 0, 16, 12).data;
    } catch (err) {
      blocked = true;               // the host refused the pixels (no CORS): hold a steady dim room
      clearInterval(timer);
      timer = null;
      root.style.setProperty('--tv-lum', '0.4');
      return;
    }
    var s = 0;
    for (var i = 0; i < d.length; i += 4) s += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
    var L = s / (d.length / 4) / 255;
    lum += (Math.min(1, L * 1.5) - lum) * EASE;
    root.style.setProperty('--tv-lum', lum.toFixed(3));
  }
  video.addEventListener('playing', function () { if (!timer && !blocked) timer = setInterval(sample, 100); });
  video.addEventListener('pause', function () { clearInterval(timer); timer = null; });
})();
